module.exports = __webpack_public_path__ + "fe4304fb29dd820ed0d15f462794e0a4.png";